import { render, staticRenderFns } from "./access.vue?vue&type=template&id=2dc32451&scoped=true&"
import script from "./access.vue?vue&type=script&lang=ts&"
export * from "./access.vue?vue&type=script&lang=ts&"
import style0 from "./access.vue?vue&type=style&index=0&id=2dc32451&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc32451",
  null
  
)

component.options.__file = "access.vue"
export default component.exports